'use strict';

var _ = require('lodash');
var DashboardToolbarController = function DashboardToolbarController($scope, $rootScope, searchCriteriaConstantsService, alertsPanelDataService, featureToggleService) {
  var defaultCogOptions = require('../config/cogOptions.json');
  var defaultCogElement = defaultCogOptions.defaults['no-submenu']['no-group'][0];
  var defaultMappedCogElement = defaultCogOptions.defaults['no-submenu']['mapped-mode'][0];
  $scope.initialScreen = searchCriteriaConstantsService.DASHBOARD;
  $scope.cogId = 'dashboard-toolbar-cog';
  $scope.cogOptions = _.clone(defaultCogOptions);
  $scope.alertsTotalNumber = 0;
  function updateAlertsNumber() {
    alertsPanelDataService.getTotalAlertsNumber().then(function (totalNumber) {
      $scope.alertsTotalNumber = totalNumber;
    });
  }
  $scope.triggerSearch = function () {
    $rootScope.$broadcast('search-criteria:searchChangeEvent');
  };
  $scope.$on('search-criteria:searchChangeEvent', function () {
    $scope.cogOptions = _.clone(defaultCogOptions);
    if (featureToggleService.isEnabled('MAPPED_MODE')) {
      $rootScope.$broadcast('cog:dashboard-toolbar-cog', {
        val: [defaultCogElement]
      });
    } else {
      $rootScope.$broadcast('cog:dashboard-toolbar-cog', {
        val: [defaultMappedCogElement]
      });
    }
  });
  $scope.$on('cog:dashboard-toolbar-cog', function (event, value) {
    $scope.cogOptions.defaults['no-submenu']['no-group'] = value.val;
  });
  $scope.$on('brush-filter:filterApplied:updateToolbar', updateAlertsNumber);
};
DashboardToolbarController.$inject = ['$scope', '$rootScope', 'SearchCriteriaConstantsService', 'AlertsPanelDataService', 'FeatureToggleService'];
module.exports = DashboardToolbarController;